import { ReferentialKey } from "api/referential";
import { mapReferentialsToDropdownItems } from "features/referentials/mappers/referentialMapper";
import { referentialsApi } from "services/swagger-api";
import { referentialCacheService } from "../../services/referentialCacheService";
import { ReferentialSyncActions } from "../types";

export const initReferentials = async (
  actions: ReferentialSyncActions,
): Promise<void> => {
  try {
    actions.setLoading(true);
    actions.setError(null);

    // Vérifier d'abord le cache
    const cachedData = referentialCacheService.getFromCache();

    if (cachedData) {
      actions.setReferentials(cachedData.referentials);
      actions.setDropdownItems(cachedData.dropdownItems);
      actions.setLoading(false);
      return;
    }

    // Si pas de cache, charger depuis l'API
    const response = await referentialsApi.getReferentials();

    if (response) {
      const referentialsData = {
        [ReferentialKey.CompanyRole]: response.companyRoles,
        [ReferentialKey.Nationality]: response.nationalities,
        [ReferentialKey.LegalForm]: response.legalForms,
        [ReferentialKey.MandateFrequency]: response.mandateFrequencies,
        [ReferentialKey.Country]: response.countries,
        [ReferentialKey.Civility]: response.civilities,
        [ReferentialKey.QuestionsContexts]: response.questionsContexts,
      };

      const dropdownItemsData = {
        [ReferentialKey.CompanyRole]: mapReferentialsToDropdownItems(response.companyRoles),
        [ReferentialKey.Nationality]: mapReferentialsToDropdownItems(response.nationalities),
        [ReferentialKey.LegalForm]: mapReferentialsToDropdownItems(response.legalForms),
        [ReferentialKey.MandateFrequency]: mapReferentialsToDropdownItems(response.mandateFrequencies),
        [ReferentialKey.Country]: mapReferentialsToDropdownItems(response.countries),
        [ReferentialKey.Civility]: mapReferentialsToDropdownItems(response.civilities),
        [ReferentialKey.QuestionsContexts]: mapReferentialsToDropdownItems(response.questionsContexts),
      };

      // Mettre à jour le state
      actions.setReferentials(referentialsData);
      actions.setDropdownItems(dropdownItemsData);

      // Sauvegarder dans le cache
      referentialCacheService.saveToCache(referentialsData, dropdownItemsData);
      console.log('Référentiels sauvegardés dans le cache');
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue');
  } finally {
    actions.setLoading(false);
  }
};
